import React from "react";
import { HiArrowNarrowRight } from "react-icons/hi";
import HeroImage from "../assets/heroImage.jpg";
import { Link } from "react-scroll";

const Home = () => {
  return (
    <div
      name="home"
      className="w-full md:h-screen bg-gradient-to-b from-black via-black to-gray-800 pt-32"
    >
      <div className=" max-w-screen-lg md:mx-auto flex flex-col md:flex-row items-center justify-center h-full px-4">
        <div className="flex flex-col justify-center h-full">
          <h2 className="text-4xl sm:text-7xl font-bold text-white hover:text-gradient-to-r from-cyan-500 to-blue-500" >
            I'm a Full Stack Developer
          </h2>
          <p className="text-gray-500 py-4 max-w-md " >
          With 1 years of experience, I specialize in web application development using React.Js, Tailwind CSS, Node.js, and MongoDB. My passion for creating efficient and user-friendly solutions drives me to stay updated with the latest web development trends. I thrive in collaborative environments and aim to contribute my expertise to impactful projects.
          </p>
          <div>
            <Link
              to="portfolio"
              smooth
              duration={500}
              className="group text-white w-fit px-6 py-3 my-2 flex items-center rounded-md bg-gradient-to-r from-cyan-500 to-blue-500 cursor-pointer"
            >
              Portfolio
              <span className="group-hover:rotate-90 duration-300">
                <HiArrowNarrowRight className="ml-1" />
              </span>
            </Link>
          </div>
        </div>
        <div>
          <img
            src={HeroImage}
            alt="my profile"
            className="rounded-2xl mx-auto w-2/3 md:w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
